import styled from "styled-components";
import { Subtitle, Title } from "../../styles/GlobalStyledComponents";

export const CancelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 60%;
    margin-top: 8px;
    @media (min-height: 700px) {
        gap: 56px;    
    }
`;

export const CancelTextSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
`;

export const CancelImage = styled.img`
    margin: 24px 0;
    max-width: 300px;
    align-self: center;
`;

export const CancelImageSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const CancelTitle = styled(Title)`
    padding: 0;
`;

export const CancelSubtitleText = styled(Subtitle)`
    font-size: 18px;
`;